import * as internationalTransfersApi from '@/network/api/internationalTransfers.api.js'

/** Request internacional corporate process list
@return { promise }
*/
export const requestInternationalCorporateProcesses = async (context, payload) => {
	const res = await internationalTransfersApi.getInternationalCorporateProcesses(payload)

	if (res) context.commit('SAVE_PROCESSES_LIST', { pageNumber: payload.pageNumber, data: res.data.data })
	return res
}

/** Request International Transfers Currencies List
@return { promise }
*/
export const requestTmxCurrencyList = async (context, payload) => {
	const res = await internationalTransfersApi.requestInternationalTransfersCurrenciesList(payload)

	if (res) context.commit('SAVE_TMX_CURRENCY_LIST', res.data)
	return res
}

/** Request International Transfers Estimated amount
@return { object }
*/
export const requestTmxEstimatedAmount = async (context, payload) => {
	const res = await internationalTransfersApi.requestTMXEstimatedAmount(payload)

	if (res) context.commit('SAVE_TMX_ESTIMATED_AMOUNT', res.data.data)
	return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
